import store from "@/store";
import router from "@/router";
import * as logRocket from "@/helpers/log-rocket";

export async function getConfigFromHsl(failSilently: boolean = false) { //TODO: don't set location without knowing which location user is logged into
  try {

    if (!(store.state as any)?.user?.location?.guid) {
      console.log("getConfigFromHsl aborting early, user must be logged in with a location selected")
      return
    }

    let response = await fetch(store.getters["settings/configDataUrl"]());
    let json;
    if (response.ok) {
      console.log("config data response ok");
      json = await response.json();
      if (!json.processingStation) throw Error(`Field "processingStation" not found in config JSON.`);
      if (!json.processingStation.description) throw Error(`Field "processingStation.description" not found in config JSON.`);
      if (!json.processingStation.guid) throw Error(`Field "processingStation.guid" not found in config JSON.`);

      if (!json.location) throw Error(`Field "location" not found in config JSON.`);
      if (!json.location.type) throw Error(`Field "location.type" not found in config JSON.`);
      if (!json.location.name) throw Error(`Field "location.name" not found in config JSON.`);
      if (!json.location.guid) throw Error(`Field "location.guid" not found in config JSON.`);

      //if (!json.hardware) throw Error(`Field "hardware" not found in config JSON.`);
      if (!json.gates) throw Error(`Field "gates" not found in config JSON.`);

      if ((store.state as any)?.user?.location?.guid && (store.state as any).user.location.guid !== json.location.guid) {
        const description = (store.state as any)?.user?.location?.description
        const guid = (store.state as any)?.user?.location?.guid
        store.commit("locationMismatchHardware", true)
        //router.push({ name: "home" });
        return //return instead of error, app will lock
        //throw Error(`Location mismatch! App's location: ${description ?? guid}, Station's location: ${json.location.name}`);
      } else {
        store.commit("locationMismatchHardware", false)
      }

      const processingStation = store.getters["getField"]("processingStation");
      const previousStationGuid = processingStation?.guid
      const newStationGuid = json.processingStation.guid
      // if (processingStation && processingStation.guid !== json.processingStation.guid)
      //   throw Error(`Error: Processing Station can not change. It was ${processingStation.description} but is now ${json.processingStation.description}`);

      //TODO: set to something like sortingGates.hslCurrentGates
      //store.commit("updateField", { path: "sortingGates.gates", value: json.gates });
      store.commit("updateField", { path: "sortingGates.currentGates", value: json.gates });
      store.commit("updateField", { path: "location", value: json.location });
      store.commit("updateField", { path: "processingStation", value: json.processingStation });
      logRocket.connectedToProxy(newStationGuid, previousStationGuid)
      //this.hasConfig = true;
    } else {
      console.error("config data response not ok");
      throw Error(`Error: failed to get hardware config (${response.status} ${response.statusText})`);
    }
  } catch (err) {
    const getConfigMessage = `v${store.state.version} getConfigFromHsl: ${err} - Url: ${store.getters["settings/configDataUrl"]()}`;
    console.error(getConfigMessage);
    if (failSilently) {
      return
    } else {
      store.commit("popup/displayOk", getConfigMessage);
      throw err;
    }
  }
}